import { render, staticRenderFns } from "./DemoNotice.vue?vue&type=template&id=6a2a2c22&"
import script from "./DemoNotice.vue?vue&type=script&lang=js&"
export * from "./DemoNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports